import React from 'react';
import { Link } from 'react-router-dom';

import routes from 'app/routes';

export default function NoData() {
  return (
    <div className="py-5 border-bottom w-100 text-center">
      <h2>This table is empty...</h2>

      <div className="mb-4">Please add your coaches to LeggUP!</div>
      <Link to={routes.managers.coaches.add} className="btn btn-primary">Add Coaches</Link>
    </div>
  );
}
